<template>
  <div style="margin-top: 30px">
    <b-overlay :show="showLoading" no-wrap />

    <b-popover      container="lg-popover"
                        target="my_popover"
                        placement="buttom"
                        triggers="hover"
                      >
                        <template #title>
                          Vente à distance - Obligations relatives au démarchage téléphonique en assurances 
                        </template>
                  
                        <p>Dans le cadre de votre mission, vous vous engagez &agrave; respecter l&rsquo;ensemble des r&egrave;gles relatives au d&eacute;marchage t&eacute;l&eacute;phonique, y compris la loi n&deg;2021-402 du 8 avril 2021, le d&eacute;cret n&deg;2022-34 du 17 janvier 2022 et le d&eacute;cret n&deg;2022-1313 du 13 octobre 2022.</p>
                        <p><u>Vos obligations </u>:</p>
                        <ul>
                            <li>Mettre en place une vente en deux temps lorsque vous d&eacute;marchez par t&eacute;l&eacute;phone un prospect qui n&rsquo;est pas client ou qui n&rsquo;a pas sollicit&eacute; votre appel de mani&egrave;re active.</li>
                            <li>Informer le prospect d&egrave;s le d&eacute;but de l&rsquo;appel que celui-ci est enregistr&eacute; et qu&rsquo;il peut obtenir une copie de cet enregistrement s&rsquo;il en fait la demande.</li>
                            <li>Mettre fin &agrave; l&rsquo;appel si le prospect refuse l&rsquo;enregistrement.</li>
                            <li>Vous vous engagez &agrave; enregistrer l&rsquo;ensemble des conversations t&eacute;l&eacute;phoniques qui auront amen&eacute; &agrave; la conclusion du contrat d&rsquo;assurance et &agrave; les conserver.&nbsp;</li>
                            <li>La signature &eacute;lectronique ne pourra intervenir lors du deuxi&egrave;me appel et vous ne pourrez pas l&rsquo;accompagner durant ce processus de signature.</li>
                            <li>S&rsquo;assurer de permettre la tra&ccedil;abilit&eacute; et l&rsquo;int&eacute;grit&eacute; de l&rsquo;ensemble des appels t&eacute;l&eacute;phoniques.</li>
                            <li>Respecter strictement le d&eacute;cret du 13 octobre 2022 encadrant les jours, horaires et fr&eacute;quence d&rsquo;appels quand celui-ci s&rsquo;applique. Les appels dans ce cas devront &ecirc;tre pass&eacute;s entre 10h et 13h et entre 14h &agrave; 20h du lundi au vendredi. Ils sont en revanche interdits les samedis, dimanches et jours f&eacute;ri&eacute;s. Cet encadrement s&#39;applique aussi bien aux personnes non inscrites sur la liste Bloctel qu&#39;&agrave; celles inscrites mais sollicit&eacute;es dans le cadre d&#39;un contrat en cours.</li>
                            <li>Limitation stricte de l&#39;acc&egrave;s aux enregistrements aux seuls agents de l&#39;Autorit&eacute; de contr&ocirc;le prudentiel et de r&eacute;solution et aux agents mentionn&eacute;s aux articles L. 511-3 et L. 511-21 du code de la consommation.</li>
                        </ul>
                        <p><u>Destruction des enregistrements</u> :</p>
                        <ul>
                            <li>Sans d&eacute;lai, lorsque le souscripteur ou l&#39;adh&eacute;rent &eacute;ventuel s&#39;est explicitement oppos&eacute; &agrave; la poursuite de la communication t&eacute;l&eacute;phonique ou &agrave; la proposition commerciale</li>
                            <li>En l&#39;absence de r&eacute;ponse favorable &agrave; une proposition commerciale, dans un d&eacute;lai d&#39;un mois &agrave; compter de la date de cette proposition (le souscripteur ou l&#39;adh&eacute;rent &eacute;ventuel manifestant ainsi une absence d&#39;int&eacute;r&ecirc;t ou son souhait de ne pas donner suite &agrave; cette proposition)</li>
                        </ul>
                      </b-popover>
    <validation-observer ref="AssureRules">
      <b-form>
        <!--Assuré principal-->
        <b-row>
          <b-col md="12">
            <b-form-group id="lg-popover">
              <label class="font-weight-normal" style="font-size: 1rem;">Cette souscription s'effectue-t-elle dans le cadre d'une vente à distance ? <span
            class="d-inline-block"
            variant="outline-primary"
            id="my_popover"
            ><feather-icon
              icon="InfoIcon"
              class=" cursor-pointer"
              size="21" /></span
        ></label>

              
              <b-form-radio-group v-model="devis.is_a_distance" :options="optionsVenteDistance" name="radio-vente-a-distance" />
            </b-form-group>

            <b-form-group label="De quel type de vente s'agit-il ?" v-if="devis.is_a_distance">
              <validation-provider #default="{ errors }" name="type de vente" rules="required">
                <b-form-radio-group v-model="devis.type_vente" name="radio-type-de-vente" :state="errors.length > 0 ? false : null">
                  <b-form-radio :value="option.value" v-for="option in optionsTypeVente" :key="option.value">
                    {{ option.text }}
                    <span v-b-popover.hover.top="option.infoBool" v-ripple.400="'rgba(113, 102, 240, 0.15)'" :title="option.text" class="ml-1 cursor-pointer" variant="outline-primary">
                      <feather-icon icon="InfoIcon" size="20" />
                    </span>
                  </b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <h4 class="title-custom-wizard"><u>Assuré principal (signataire)</u></h4>
          </b-col>
          <b-col md="12">
            <b-row>
              <!-- Civilité -->
              <b-col md="3">
                <b-form-group label="Civilité *" label-for="assure_civilite">
                  <validation-provider #default="{ errors }" name="civilité" rules="required">
                    <b-form-select v-model="prospect.civilite" :options="civilite" id="assure_civilite" :state="errors.length > 0 ? false : null" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Nom -->
              <b-col md="3">
                <b-form-group label="Nom *" label-for="assure_nom">
                  <div class="form-control" readonly disabled v-if="prospect.statut_gda=='ORANGE' || prospect.statut_gda=='ROUGE' || prospect.statut_gda=='VERT'">{{ prospect.nom }}</div>
                  <validation-provider v-else #default="{ errors }" name="nom" rules="required">
                    <!-- <b-form-input v-if="prospect.statut_gda==='VERT'" v-model="prospect.nom" disabled :state="errors.length > 0 ? false : null" id="assure_nom" class="text-capitalize" placeholder="Nom" type="text" /> -->
                    
                    <b-form-input v-model="prospect.nom" :state="errors.length > 0 ? false : null" id="assure_nom" class="text-capitalize" placeholder="Nom" type="text" />

                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Prénom -->
              <b-col md="3">
                <b-form-group label="Prénom *" label-for="assure_prenom">
                  <div class="form-control" readonly disabled v-if="prospect.statut_gda=='ORANGE' || prospect.statut_gda=='ROUGE' || prospect.statut_gda=='VERT'">{{ prospect.prenom }}</div>
                  <validation-provider v-else #default="{ errors }" name="prénom" rules="required">
                    <!-- <b-form-input v-if="prospect.statut_gda==='VERT'" v-model="prospect.prenom" :state="errors.length > 0 ? false : null" id="assure_prenom" disabled class="text-capitalize" placeholder="Prénom" type="text" /> -->

                    <b-form-input   v-model="prospect.prenom"  :state="errors.length > 0 ? false : null" id="assure_prenom"  class="text-capitalize" placeholder="Prénom" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
                 <!-- Date de naissance -->
                 <b-col md="3">
                <b-form-group label="Date de naissance *" label-for="date-naissance">
                  <div class="form-control" readonly disabled v-if="prospect.statut_gda=='ORANGE' || prospect.statut_gda=='ROUGE' || prospect.statut_gda=='VERT'">{{ prospect.date_naissance }}</div>

                  <validation-provider v-else #default="{ errors }" name="date de naissance" rules="required">
                    <!-- <flat-pickr v-if="prospect.statut_gda==='VERT'" id="date-naissance" disabled v-model="prospect.date_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control" placeholder="Date de naissance" autocomplete="off" /> -->

                    <flat-pickr id="date-naissance" v-model="prospect.date_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control" placeholder="Date de naissance" autocomplete="off" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="errorDateNaissanceProspect ? false : null"> {{ errorDateNaissanceProspect }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- Nom de naissance -->
              <b-col md="3">
                <b-form-group label="Nom de naissance *" label-for="assure-nom-naissance">
                  <validation-provider #default="{ errors }" name="nom de naissance" rules="required">
                    <b-form-input v-model="prospect.nom_naissance" :state="errors.length > 0 ? false : null" id="assure-nom-naissance" class="text-capitalize" placeholder="Nom de naissance" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Code postal de naissance -->
              <b-col md="3">
                <b-form-group label="Code postal de naissance *" label-for="assure-code-postal-naissance">
                  <validation-provider #default="{ errors }" name="code postal de naissance" rules="required">
                    <b-form-input id="assure-code-postal-naissance" v-model="prospect.code_postal_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" type="text" :raw="false" class="text-uppercase" placeholder="Code postal de naissance" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Commune de naissance -->
              <b-col md="3">
                <b-form-group label="Commune de naissance *" label-for="assure-commune-naissance">
                  <validation-provider #default="{ errors }" name="commune de naissance" rules="required">
                    <b-form-input v-model="prospect.commune_naissance" :state="errors.length > 0 ? false : null" class="text-capitalize" id="assure-commune-naissance" placeholder="Commune de naissance" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Pays de naissance -->
              <b-col md="3">
                <!-- <b-form-group label="Pays de naissance *">
                  <validation-provider #default="{ errors }" name="pays de naissance" rules="required">
                    <b-form-input v-model="prospect.pays_naissance" :state="errors.length > 0 ? false : null" class="text-capitalize" placeholder="pays de naissance" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group> -->
                <validation-provider #default="{ errors }" name="pays de naissance" rules="required">
                  <b-form-group label="Pays de naissance *" label-for="assure-pays-naissance">
                    <v-select v-model="prospect.pays_naissance" id="assure-pays-naissance" :close-on-select="true" :reduce="pays => pays.pays" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="pays" class="flex-grow-1" :state="errors.length > 0 ? false : null" input-id="pays" label="pays" placeholder="Pays de naissance">
                      <template #option="{ pays }">
                        <span class="ml-50"> {{ pays }}</span>
                      </template>

                      <template #selected-option="{ pays }">
                        <span class="ml-50"> {{ pays }}</span>
                      </template>
                      <div slot="no-options">Aucune pays disponible.</div>
                    </v-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="align-items-center mb-1">
              <!-- Régime de sécurité sociale -->
              <b-col md="3">
                <b-form-group label="Régime de sécurité sociale *" label-for="regime">
                  <validation-provider #default="{ errors }" name="régime de sécurité sociale" rules="required" vid="type_regime_chosen">
                    <b-form-select v-model="prospect.regime_obligatoire" :options="regimeOptions" :state="errors.length > 0 ? false : null" @change="initRegimeObjet($event, 'SOUSCRIPTEUR')" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Code postal -->
              <b-col md="3">
                <b-form-group label="Code postal *" label-for="code postal">
                  <validation-provider #default="{ errors }" name="code postal" rules="required|length:5">
                    <cleave id="code-postal" v-model="prospect.moyen_contact.code_postal" :class="errors.length > 0 ? 'is-invalid' : ''" :options="options.codePostal" :raw="false" class="form-control" placeholder="Code postal" type="number" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Ville -->
              <b-col md="3">
                <b-form-group label="Ville *" label-for="ville">
                  <validation-provider #default="{ errors }" name="ville" rules="required">
                    <b-form-select v-model="prospect.moyen_contact.ville_id" :state="errors.length > 0 ? false : null">
                      <b-form-select-option :value="null">Choisissez</b-form-select-option>
                      <b-form-select-option v-for="ville in villeOptions" :value="ville.id" :key="ville.id">{{ ville.ville }}</b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Date d'effet -->
              <b-col md="3">
                <span v-b-popover.hover.top.html="infoDateEffet" v-ripple.400="'rgba(113, 102, 240, 0.15)'" title="Informations" class="" variant="outline-primary">
                <b-form-group label="Date d'effet *" label-for="date-effet">
                  <validation-provider #default="{ errors }" name="date d'effet" rules="required">
                    <flat-pickr id="date-effet" v-model="objetSanteActif.date_effet" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configdateEffet" class="form-control" placeholder="Date d'effet" rules="required" autocomplete="off" />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </span>
              </b-col>
              <b-col md="3" v-if="prospect.regime_obligatoire == 'REGIME_AGRICOLE'">
                <b-form-group>
                  <label class="font-weight-normal">Merci de préciser le régime :</label>
                  <validation-provider v-slot="{ errors }" name="régime" rules="requiredRegimeAgricole">
                    <b-form-radio-group v-model="objetSanteActif.regime_obligatoire" :options="regimesAMEXA">
                    </b-form-radio-group>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ régime est obligatoire</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="!devis.loi_madelin">
                <b-alert-regime-non-salaries :regimeSelected="objetSanteActif.regime_obligatoire" />
              </b-col>
              <b-col md="12">
                <b-form-group label="L'assuré, ou une ou des personnes de son entourage étroitement associées, exercent-ils ou ont-ils cessé d'exercer depuis moins d'un an des fonctions politiques, juridictionnelles ou administratives ? (pour plus de détails, voir l'onglet FAQ)">
                  <validation-provider v-slot="{ errors }" name="personne politiquement exposée" rules="required" vid="is_ppe_ass_conjoint_a_assurer">
                    <b-form-radio-group id="ppe_1_option_sante_actifs" v-model="prospect.isPPE" :options="BooleanValue" label="Prospect à assurer"></b-form-radio-group>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          
          <b-col md="3">
            <b-form-group label="Conjoint à assurer ?">
              <validation-provider v-slot="{ errors }" name="Conjoint à assurer" rules="required" vid="is_conjoint_a_assurer">
                <b-form-radio-group id="conjoint_option_sante_actifs" v-model="objetSanteActif.conjoint" :options="BooleanValue" label="Conjoint à assurer"></b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Le proposant est-il éligible au cadre du RIA ?">
              <validation-provider v-slot="{ errors }" name="le proposant est-il éligible au cadre du RIA" rules="required">
                <b-form-radio-group v-model="objetSanteActif.ria" :options="BooleanValue" label="Je souhaite réaliser une RIA pour le client"></b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="objetSanteActif.regime_obligatoire == 'RÉGIME_SOCIAL'">
            <b-form-group label="Le client souhaite-t-il bénéficier de la loi Madelin ?">
              <b-form-radio-group
                label="Le client souhaite-t-il bénéficier de la loi Madelin ?"
                v-model="devis.loi_madelin"
                name="madelinValue"
                :options="BooleanValue"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-alert variant="danger" show v-show="objetSanteActif.ria" class="mt-1">
          <div class="alert-body">
            <p>Attention&nbsp;: La R&eacute;siliation Infra Annuelle (RIA) ne concerne que les contrats (automobile, habitation et sant&eacute;) souscrits depuis plus d&rsquo;un an. La date d'effet du nouveau contrat doit intervenir imm&eacute;diatement apr&egrave;s la r&eacute;siliation du premier contrat. La r&eacute;glementation pr&eacute;voit que le nouveau contrat prend effet 30 jours &agrave; compter de la r&eacute;ception de la r&eacute;siliation par l&rsquo;ancien assureur.</p>
            <p>Un mandat de r&eacute;siliation sera propos&eacute; &agrave; la signature en fin de parcours et devra &ecirc;tre adress&eacute; par vos soins &agrave; l&rsquo;ancien assureur.</p>
            <p>Pour prendre en compte le d&eacute;lai de r&eacute;alisation de ces d&eacute;marches, BubbleIn pr&eacute;voit donc une prise d&rsquo;effet au plus t&ocirc;t le {{ riaDate }} soit 35 jours (+24h en cas de vente en 2 temps) &agrave; compter d&rsquo;aujourd&rsquo;hui. Nous vous invitons n&eacute;anmoins &agrave; prendre une marge de man&oelig;uvre suppl&eacute;mentaire en fonction du temps estim&eacute; de votre d&eacute;marche commerciale. &nbsp;Merci de v&eacute;rifier et modifier le cas &eacute;ch&eacute;ant l&rsquo;option et la date renseign&eacute;es ci-dessus.</p>
            <p>Si le contrat a moins d'un an, l&rsquo;assur&eacute; doit proc&eacute;der lui-m&ecirc;me &agrave; la r&eacute;siliation de son contrat &agrave; l'&eacute;ch&eacute;ance anniversaire, en respectant les d&eacute;lais de pr&eacute;avis pr&eacute;vus au contrat.</p>
          </div>
        </b-alert>
        <!--Conjoint-->
        <b-row v-if="objetSanteActif.conjoint" class="align-items-center mb-1">
          <b-col md="12" sm="12">
            <h4 class="title-custom-wizard mt-2"><u>Conjoint</u></h4>
          </b-col>
          <!-- Civilité -->
          <b-col md="3">
            <b-form-group label="Civilité *" label-for="conjoint-civilite">
              <validation-provider #default="{ errors }" name="civilité du conjoint" rules="required">
                <b-form-select v-model="conjoint.civilite" :options="civilite" id="conjoint-civilite" :state="errors.length > 0 ? false : null" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ civilité du conjoint est obligatoire </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Nom -->
          <b-col md="3">
            <b-form-group label="Nom *" label-for="conjoint-nom">
              <div class="form-control" readonly disabled v-if="conjoint.statut_gda=='ORANGE' || conjoint.statut_gda=='ROUGE' || conjoint.statut_gda=='VERT'">{{ conjoint.nom }}</div>

              <validation-provider v-else #default="{ errors }" name="nom du conjoint" rules="required">
                <b-form-input  id="conjoint-nom" v-model="conjoint.nom" :state="errors.length > 0 ? false : null" class="text-capitalize" placeholder="Nom" type="text" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ nom du conjoint est obligatoire </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Prénom -->
          <b-col md="3">
            <b-form-group label="Prénom *" label-for="conjoint-prenom">
              <div class="form-control" readonly disabled v-if="conjoint.statut_gda=='ORANGE' || conjoint.statut_gda=='ROUGE' || conjoint.statut_gda=='VERT'">{{ conjoint.prenom }}</div>
              <validation-provider v-else  #default="{ errors }" name="prénom du conjoint" rules="required">
                <b-form-input id="conjoint-prenom" v-model="conjoint.prenom" :state="errors.length > 0 ? false : null" class="text-capitalize" placeholder="Prénom" type="text" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ prénom du conjoint est obligatoire </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Date de naissance -->
          <b-col md="3">
            <b-form-group label="Date de naissance *" label-for="conjoint-date-naissance">
              <div class="form-control" readonly disabled v-if="conjoint.statut_gda=='ORANGE' || conjoint.statut_gda=='ROUGE' || conjoint.statut_gda=='VERT'">{{ conjoint.date_naissance }}</div>
              <validation-provider v-else  #default="{ errors }" name="date de naissance du conjoint" rules="required">
                <flat-pickr id="conjoint-date-naissance" v-model="conjoint.date_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control" placeholder="Date de naissance" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ date de naissance du conjoint est obligatoire </b-form-invalid-feedback>
                <b-form-invalid-feedback :state="errorDateNaissanceConjoint ? false : null"> {{ errorDateNaissanceConjoint }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
              <!-- Nom de naissance -->
              <b-col md="3">
                <b-form-group label="Nom de naissance *" label-for="conjoint_nom_naissance">
                  <validation-provider #default="{ errors }" name="nom de naissance du conjoint" rules="required">
                    <b-form-input v-model="conjoint.nom_naissance" :state="errors.length > 0 ? false : null" id="conjoint_nom_naissance" class="text-capitalize" placeholder="Nom de naissance" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Code postal de naissance -->
              <b-col md="3">
                <b-form-group label="Code postal de naissance *" label-for="conjoint-code-postal-naissance">
                  <validation-provider #default="{ errors }" name="code postal de naissance du conjoint" rules="required">
                    <b-form-input id="conjoint-code-postal-naissance" v-model="conjoint.code_postal_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" type="text" :raw="false" class="text-uppercase" placeholder="Code postal de naissance" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Commune de naissance -->
              <b-col md="3">
                <b-form-group label="Commune de naissance *" label-for="conjoint-commune-naissance">
                  <validation-provider #default="{ errors }" name="commune de naissance du conjoint" rules="required">
                    <b-form-input v-model="conjoint.commune_naissance" :state="errors.length > 0 ? false : null" class="text-capitalize" id="conjoint-commune-naissance" placeholder="Commune de naissance" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Pays de naissance -->
              <b-col md="3">
                <validation-provider #default="{ errors }" name="pays de naissance du conjoint" rules="required">
                  <b-form-group label="Pays de naissance *" label-for="pays-naissance">
                    <v-select v-model="conjoint.pays_naissance" :close-on-select="true" :reduce="pays => pays.pays" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="pays" class="flex-grow-1" :state="errors.length > 0 ? false : null" input-id="pays" label="pays" placeholder="Pays de naissance">
                      <template #option="{ pays }">
                        <span class="ml-50"> {{ pays }}</span>
                      </template>

                      <template #selected-option="{ pays }">
                        <span class="ml-50"> {{ pays }}</span>
                      </template>
                      <div slot="no-options">Aucune pays disponible.</div>
                    </v-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
          <!-- Régime -->
          <b-col md="3">
            <b-form-group label="Régime *" label-for="conjoint-regime">
              <validation-provider #default="{ errors }" name="régime" rules="required" vid="type_regime_chosen">
                <b-form-select id="conjoint-regime" v-model="conjoint.regime_obligatoire" :options="regimeOptions" :state="errors.length > 0 ? false : null" @change="initRegimeObjet($event, 'CONJOINT')"/>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="conjoint.regime_obligatoire == 'REGIME_AGRICOLE'">
            <b-form-group>
              <label class="font-weight-normal">Merci de préciser le régime :</label>
              <validation-provider v-slot="{ errors }" name="régime conjoint" rules="required">
                <b-form-radio-group v-model="objetSanteActif.regime_obligatoire_conjoint" :options="regimesAMEXA">
                </b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ régime est obligatoire</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="!devis.loi_madelin">
            <b-alert-regime-non-salaries :regimeSelected="conjoint.regime_obligatoire" />
          </b-col>
          <b-col md="12">
            <b-form-group label="Le conjoint, ou une ou des personnes de son entourage étroitement associées, exercent-ils ou ont-ils cessé d'exercer depuis moins d'un an des fonctions politiques, juridictionnelles ou administratives ? (pour plus de détails, voir l'onglet FAQ)">
              <validation-provider v-slot="{ errors }" name="personne politiquement exposée" rules="required">
                <b-form-radio-group id="ppe_2_option_sante_actifs" v-model="getEtude.Conjoint.isPPE" :options="BooleanValue" label="Conjoint à assurer"></b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
                <b-form-group label="Enfant(s) à assurer ?" label-for="enfant">
                  <b-form-input
                    id="enfant"
                    type="number"
                    v-model="objetSanteActif.enfantCharge"
                    placeholder="Nombre d'enfants"
                  />
                  <b-form-invalid-feedback :state="!$v.objetSanteActif.enfantCharge.$error">
                    <span v-if="!$v.objetSanteActif.enfantCharge.required">Veuillez renseigner le(s) champ(s) obligatoire(s)</span>
                    <span v-if="!$v.objetSanteActif.enfantCharge.between" class="error">Veuillez renseigner une valeur entre 0 et 10</span>
                  </b-form-invalid-feedback>
                </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="objetSanteActif.enfantCharge>0" class="mb-3">
          <b-col md="12" sm="12">
            <h4 class="title-custom-wizard mt-2"><u>Enfants</u></h4>
          </b-col>
          <b-col md="12" sm="12">
            <div v-if="objetSanteActif.enfantCharge>0">
              <b-row>
                <div class="col-12 mb-1">
                  <span style="font-size:14px">Sélectionnez les enfants à assurer : </span>
                </div>
              </b-row>
              <b-row v-for="(enf,index) in enfantsArray" :key="index" class="mb-3">
                <b-col md="1" class="d-inline text-center" style="margin-top:30px">
                  <b-form-group class="d-inline">
                    <b-form-checkbox v-model="enf.state" :disabled="!hasPerToCheck && !enf.state" class="d-inline">
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group>
                    <label for="nom">Nom :</label>
                    <div class="form-control" readonly disabled v-if="enf.statut_gda==='VERT' || enf.statut_gda==='ROUGE' || enf.statut_gda==='ORANGE' ">{{ enf.nom }}</div>

                    <b-form-input v-else
                      id="nom"
                      v-model="enf.nom"
                      autocomplete="nope"
                      type="text"
                      placeholder="Nom"
                      class="text-capitalize"
                    />
                    <b-form-invalid-feedback :state="!$v.enfantsArray.$each[index].nom.$error">
                      Veuillez renseigner le(s) champ(s) obligatoire(s
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group>
                    <label for="nom">Prénom :</label>
                    <div class="form-control" readonly disabled v-if="enf.statut_gda==='VERT' || enf.statut_gda==='ROUGE' || enf.statut_gda==='ORANGE' ">{{ enf.prenom }}</div>

                    <b-form-input v-else
                      id="nom"
                      v-model="enf.prenom"
                      autocomplete="nope"
                      type="text"
                      placeholder="Prénom"
                      class="text-capitalize"
                    />
                    <b-form-invalid-feedback :state="!$v.enfantsArray.$each[index].prenom.$error">
                      Veuillez renseigner le(s) champ(s) obligatoire(s
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group>
                    <label for="date_naissance">Date de naissance :</label>
                    <div class="form-control" readonly disabled
                      v-if="enf.statut_gda==='VERT' || enf.statut_gda==='ROUGE' || enf.statut_gda==='ORANGE' ">
                      {{ enf.date_naissance }}</div>

                    <flat-pickr v-else class="form-control" v-model="enf.date_naissance" id="date-naissance"
                      :config="config" placeholder="Date de naissance" data-max-date="today" />
                    <b-form-invalid-feedback :state="!$v.enfantsArray.$each[index].date_naissance.$error">
                      Veuillez renseigner le(s) champ(s) obligatoire(s)
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <!-- Régime de sécurité sociale -->
          <b-col md="3" class="offset-1">
            <b-form-group>
              <label for="regime_enf">Régime de sécurité sociale *</label>
                <b-form-select v-model="enf.regime_obligatoire_enf" id="regime_enf" :options="regimeOptions" />
                  <b-form-invalid-feedback :state="!$v.enfantsArray.$each[index].regime_obligatoire_enf.$error">
                      Veuillez renseigner le(s) champ(s) obligatoire(s)
                    </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
                <b-col md="2" class="text-center" style="margin-top:30px" v-if="!enf.id">
                  <div class="d-inline" @click="removeEnfant(index)">
                    <feather-icon icon="XIcon" size="22" class="mr-50" />
                  </div>
                </b-col>
      <b-col md="11" class="offset-1" v-if="!devis.loi_madelin">
        <b-alert-regime-non-salaries :regimeSelected="enf.regime_obligatoire_enf" />
      </b-col>

                <!-- <b-col md="12" offset="1">
                  <b-form-group class="mb-0 mt-1"> 
                    <label class="float-left pr-2">Je déclare que l’enfant poursuit des études et qu’il est
                      couvert par le régime du souscripteur ou par un régime étudiant</label>
                    <b-form-radio-group :id="`poursuit_etude_option_${index}`" :options="BooleanValue" v-model="enf.poursuit_etude">
                    </b-form-radio-group>
                    <b-form-invalid-feedback :state="!$v.enfantsArray.$each[index].poursuit_etude.$error">
                      Veuillez renseigner le(s) champ(s) obligatoire(s)
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col> -->
              </b-row>
            </div>
          </b-col>
          <b-col md="12" sm="12" v-if="objetSanteActif.enfantCharge>0" class="mt-1">
            <b-button @click="addEnfant" v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm"
              variant="outline-primary">
              <feather-icon icon="PlusIcon" />
              <span class="align-middle">Ajouter un Enfant</span>
            </b-button>
          </b-col>
        </b-row> 
      </b-form>
    </validation-observer>
    <!-- Garanties -->
    <!-- Text -->
    <b-row class="mt-4">
      <b-col md="12">
        <h4 class="title-custom-wizard"><u>Garanties</u></h4>
      </b-col>
    </b-row>

    <!-- Boucle -->
    <b-row v-for="(garantie, gr) in garanties.slice(0, 1)" :key="gr + 'garanties'">
      <b-col class="mt-2" md="12">
        <label>Quel est le besoin exprimé par le client ?</label>
        <div class="demo-inline-spacing mt-0 mb-2">
          <b-form-radio v-for="(gn, cpt) in garantie.garantieniveaux" :key="cpt + 'garantiesNiveaux'" v-model="garantie.garantieNiveauID" :value="[gn.id]" class="custom-control-primary">
            <span>{{ gn.garantie_niveau_libel }}</span>
            <span v-b-popover.hover.top="gn.garantie_details" v-ripple.400="'rgba(113, 102, 240, 0.15)'" :title="gn.garantie_niveau_libel" class="ml-1 cursor-pointer" variant="outline-primary">
              <feather-icon icon="InfoIcon" size="20" />
            </span>
          </b-form-radio>
        </div>
        <b-form-invalid-feedback :state="!hasSelectedGarantie"> Veuillez renseigner le(s) champ(s) obligatoire(s) </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <!-- Text -->
    <b-row class="mt-2">
      <b-col md="12">
        <label>Préciser par garantie</label><br />
        <span style="font-size: 10px">Attention à bien vérifier la cohérence avec le besoin exprimé par le client.</span>
      </b-col>
    </b-row>

    <!-- Exigences -->
    <!-- Boucle -->
    <b-row>
      <b-col v-for="(exigence, er) in exigences" :key="er + 'exigences'" class="mt-2" md="6">
        <label>{{ titleClass(exigence.label) }} </label>
        <div class="demo-inline-spacing mt-0 mb-2">
          <b-form-radio v-for="(en, cpt) in exigence.exigenceniveaux" :key="cpt + 'exigencesNiveaux'" v-model="exigences[er].exigenceNiveauID" :value="[en.id]" class="custom-control-primary">
            <span v-b-popover.hover.top="explicationExigenceNiveauLibel(exigence.label, en.exigence_niveau_libel)" v-ripple.400="'rgba(113, 102, 240, 0.15)'" :title="titleClass(en.exigence_niveau_libel)" class="cursor-pointer" variant="outline-primary">
              {{ titleClass(en.exigence_niveau_libel) }}
            </span>
          </b-form-radio>
        </div>
        <b-form-invalid-feedback :state="!unselectedExigenceIds.includes(exigence.id)"> Veuillez renseigner le(s) champ(s) obligatoire(s) </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <!-- Buttons -->
    <b-row class="mt-4">
      <b-col lg="12">
        <b-button class="float-left" size="lg" variant="primary" @click="backStep"> Précédent </b-button>
        <b-button class="float-right" size="lg" variant="primary" @click="checkValidateField(0)"> Suivant </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BPopover, BButton, VBPopover, BCol, BFormCheckbox, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormRadio, BFormRadioGroup, BFormSelect, BOverlay, BRow, VBTooltip, BAlert, BFormSelectOption } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import ToastificationContentVue from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {required,requiredIf,minLength,maxLength,between,email} from "vuelidate/lib/validators";
import BAlertRegimeNonSalaries from '@core/components/b-alert/BAlertRegimeNonSalaries.vue'
export default {
   components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BOverlay,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    BAlert,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContentVue,
    flatPickr,
    Cleave, BPopover,
    BFormSelectOption,
    BAlertRegimeNonSalaries
  },
  data() {
    return {
      infoDateEffet:"<b>ECA</b> : A partir du 16 du mois, la date d’effet minimum doit être le 1er jour du mois suivant<br><br><b>SPVIE</b> : La date d’effet minimum doit être la date du jour+1",
      is_a_distance_info:"Dans le cadre de votre mission, vous vous engagez à respecter l’ensemble des règles relatives au démarchage téléphonique, y compris la loi n°2021-402 du 8 avril 2021, le décret n°2022-34 du 17 janvier 2022 et le décret n°2022-1313 du 13 octobre 2022.<br><br><b>Vos obligations :</b><br><br>- Mettre en place une vente en deux temps lorsque vous démarchez par téléphone un prospect qui n’est pas client ou qui n’a pas sollicité votre appel de manière active.<br><br>-  Informer le prospect dès le début de l’appel que celui-ci est enregistré et qu’il peut obtenir une copie de cet enregistrement s’il en fait la demande.<br><br>- Mettre fin à l’appel si le prospect refuse l’enregistrement.<br><br>- Vous vous engagez à enregistrer l’ensemble des conversations téléphoniques qui auront amené à la conclusion du contrat d’assurance et à les conserver.<br><br>-  La signature électronique ne pourra intervenir lors du deuxième appel et vous ne pourrez pas l’accompagner durant ce processus de signature.<br><br>-  S’assurer de permettre la traçabilité et l’intégrité de l’ensemble des appels téléphoniques.<br><br>- Respecter strictement le décret du 13 octobre 2022 encadrant les jours, horaires et fréquence d’appels quand celui-ci s’applique. Les appels dans ce cas devront être passés entre 10h et 13h et entre 14h à 20h du lundi au vendredi. Ils sont en revanche interdits les samedis, dimanches et jours fériés. Cet encadrement s'applique aussi bien aux personnes non inscrites sur la liste Bloctel qu'à celles inscrites mais sollicitées dans le cadre d'un contrat en cours.<br><br>- Limitation stricte de l'accès aux enregistrements aux seuls agents de l'Autorité de contrôle prudentiel et de résolution et aux agents mentionnés aux articles L. 511-3 et L. 511-21 du code de la consommation.<br><br><b>Destruction des enregistrements :</b><br><br>-  Sans délai, lorsque le souscripteur ou l'adhérent éventuel s'est explicitement opposé à la poursuite de la communication téléphonique ou à la proposition commerciale<br><br>- En l'absence de réponse favorable à une proposition commerciale, dans un délai d'un mois à compter de la date de cette proposition (le souscripteur ou l'adhérent éventuel manifestant ainsi une absence d'intérêt ou son souhait de ne pas donner suite à cette proposition)",
      riaDate: null,
      pays: [],
      villeOptions: [],
      civilite: [
        { value: null, text: 'Choisissez' },
        { value: 'MR', text: 'M.' },
        { value: 'MME', text: 'Mme' }
      ],
      optionsVenteDistance: [
        { text: 'Oui', value: 1 },
        { text: 'Non', value: 0 }
      ],
      optionsTypeVente: [
        { text: 'Vente à distance en 1 temps', value: 'optin', infoBool: 'Prospect ayant préalablement consenti à l’appel ou client.' },
        { text: 'Vente à distance en 2 temps', value: 'optout', infoBool: 'Prospect n’ayant pas consenti à l’appel. Un délai de 24h s’appliquera avant la mise en place de la signature électronique.' }
      ],
      showLoading: false,
      errorDateNaissanceProspect: null,
      errorDateNaissanceConjoint: null,
      // Data implemented
      enfantsArray:[],
      enfant:{
        date_naissance:null,
        state:false,
        type_lien_familial:'ENFANT',
        regime_obligatoire_enf:null
      },
      objetSanteActif: {
        conjoint: 0,
        enfantCharge:0,
        date_effet: null,
        regime_obligatoire: null,
        regime_obligatoire_conjoint: null
      },
      enfantStore:[],
      prospect: {
        date_naissance: null
      },
      conjoint: {
        id: null,
        nom: null,
        prenom: null,
        date_naissance: null,
        type_lien_familial: 'CONJOINT',
        nom_naissance: null,
        code_postal_naissance: null,
        commune_naissance: null,
        pays_naissance: null,
      },
      garanties: [],
      exigences: [],
      devis: null,

      // Configuration
      regimeOptions: [
        {
          value: null,
          text: 'Choisissez',
          disabled: true
        },
        {
          value: 'REGIME_GENERAL',
          text: 'Régime général de la sécurité sociale'
        },
        {
          value: 'RÉGIME_SOCIAL',
          text: 'Régime des travailleurs non salariés et non agricoles (ex RSI)'
        },
        {
          value: 'REGIME_AGRICOLE',
          text: 'Mutualité sociale agricole (AMEXA)'
        },
        {
          value: 'REGIME_ALSACE_MOSELLE',
          text: 'Régime Alsace-Moselle'
        }
      ],
      regimesAMEXA: [
        {
          value: 'EXPLOITANTS_AGRICOLES',
          text: 'Exploitants agricoles'
        },
        {
          value: 'SALARIE_AGRICOLE',
          text: 'Salarié agricole'
        }
      ],
      BooleanValue: [
        {
          value: 1,
          text: 'Oui'
        },
        {
          value: 0,
          text: 'Non'
        }
      ],
      options: {
        codePostal: {
          blocks: [5]
        },
        codePostalNaiss: {
          lowercase: true
        }
      },
      config: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement
            var val = ele.value

            if ((val.length == 2 || val.length == 5) && ele.getAttribute('id')) {
              val += '/'
            }
            ele.value = val
            ele.dispatchEvent(new Event('input'))
          }
        }
      },
      configDateNaissance: {
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement
            var val = ele.value
            
            if ((val.length == 2 || val.length == 5) && ele.getAttribute('id')) {
              val += '/'
            }
            ele.value = val
            ele.dispatchEvent(new Event('input'))
          }
        }
      },
      configdateEffet: {
        dateFormat: 'd/m/Y',
        disable: [
          function (date) {
            const today = new Date()
            today.setDate(today.getDate())
            today.setHours(0, 0, 0, 0)
            return date < today
          },
          function (date) {
            const dateMaxSPVIE = new Date()
            dateMaxSPVIE.setFullYear(dateMaxSPVIE.getFullYear() + 1);
            dateMaxSPVIE.setHours(0, 0, 0, 0)
            const datePlusMonth = dateMaxSPVIE
            return datePlusMonth < date
          }
        ],
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement
            var val = ele.value

            if ((val.length == 2 || val.length == 5) && ele.getAttribute('id')) {
              val += '/'
            }
            ele.value = val
            ele.dispatchEvent(new Event('input'))
          }
        }
      },

      hasSelectedGarantie: false,
      unselectedExigenceIds: [],
      ppe:{
        assure:false,
        conjoint:false
      }
    }
  },
  validations: {
    objetSanteActif: { 
      enfantCharge:{ required,between: between(0,10) }
    },
    enfant: { 
        date_naissance:{ required },
    },
    enfantsArray: {
      $each: {
        nom: {
          required
        },
        prenom: {
          required
        },
        date_naissance: {
          required
        },
        poursuit_etude: {
          required
        },
        regime_obligatoire_enf:{
          required
        }
      }
    },
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-popover': VBPopover,
    Ripple
  },
  computed: {
    ...mapGetters(['getEtude']),
    hasPerToCheck: function () {
      let enfantChecked = _.filter(this.enfantsArray, enf => enf.state);
      return this.objetSanteActif.enfantCharge>enfantChecked.length
    },
    enfantsChecked: function () {
      let enfantChecked = _.filter(this.enfantsArray, enf => enf.state );
      return this.objetSanteActif.enfantCharge==0 ? true : this.objetSanteActif.enfantCharge==enfantChecked.length
    },
    enfantsHasValidDateNaissance: function () {
      // let enfantNovalidDate = _.filter(this.enfantsArray, enf => enf.state && moment().diff(enf.date_naissance.split("/").reverse().join("-"), 'years',true)>=28 );
      // return this.objetSanteActif.enfantCharge==0 || enfantNovalidDate.length==0 ? true : false
      return true
    }
  },
  watch: {
    'prospect.moyen_contact.code_postal': {
      immediate: true,
      handler(val) {
        console.log(this.prospect)
        if (val && val.length === 5) {
        this.$http
            .get(`/helpers/${val}/villes`)
            .then(res => {
              if (res.data?.length > 0) {
                this.villeOptions = [...res.data]
                let obj = this.villeOptions.find(o => o.id === this.prospect.moyen_contact.ville_id);
                if(typeof obj === 'undefined' || obj === null)
                {
                  this.prospect.moyen_contact.ville_id = null
                }
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          this.villeOptions = []
        }
      }
    },
    'objetSanteActif.ria': {
      handler(val) {
        if (val) {
          if (this.devis.type_vente == 'optout') {
            this.riaDate = moment().add(36, 'days').format('DD/MM/YYYY')
            this.changeDisabledDate(36)
          } else {
            this.riaDate = moment().add(35, 'days').format('DD/MM/YYYY')
            this.changeDisabledDate(35)
          }
        } else {
          this.changeDisabledDate(0)
        }
      }
    },
    'devis.type_vente': {
      handler(val) {
        if (this.objetSanteActif.ria) {
          if (val == 'optout') {
            this.riaDate = moment().add(36, 'days').format('DD/MM/YYYY')
            this.changeDisabledDate(36)
          } else {
            this.riaDate = moment().add(35, 'days').format('DD/MM/YYYY')
            this.changeDisabledDate(35)
          }
        } else {
          this.changeDisabledDate(0)
        }
      }
    },
    'devis.is_a_distance': {
      handler(val) {
        if (!val) {
          this.devis.type_vente = null
        }
      }
    },
    'enfantsArray':{
      handler(val){
        val = this.setPoursuitEtudeEnfantBySelectedRegime(val)
      },deep:true
    },
    'prospect.regime_obligatoire': {
      handler(val) {
        if (val != 'RÉGIME_SOCIAL') {
          this.devis.loi_madelin = 0
        }
        this.setPoursuitEtudeEnfantBySelectedRegime(this.enfantsArray);
      }
    },
    getEtude: {
      handler: function (old, nld) {
        this.prospect = old.Tiers
        this.conjoint = old.Conjoint
        this.garanties = old.itemsRisque.ItemsRisque.length > 0 ? old.itemsRisque.ItemsRisque[0].garanties : null
        this.exigences = old.itemsRisque.ItemsRisque.length > 0 ? old.itemsRisque.ItemsRisque[0].exigences : null
        // this.orderExigences()
        this.devis = old.itemsRisque.ItemsRisque.length > 0 ? old.itemsRisque.ItemsRisque[0].devis : null
        this.enfantStore = old.Enfant.Enfant
        this.objetSanteActif =
          old.itemsRisque.ItemsRisque.length > 0
            ? old.itemsRisque.ItemsRisque[0].objets.objet_sante_actifs
            : {
                conjoint: 0,
                enfantCharge: 0,
                date_effet: null,
                regime_obligatoire: null,
                regime_obligatoire_conjoint: null
              }
              if(this.objetSanteActif.regime_obligatoire == null && this.prospect.regime_obligatoire != null){

                this.objetSanteActif.regime_obligatoire = this.prospect.regime_obligatoire
              }
      },
      deep: true,
      immediate: true
    },
    'objetSanteActif.date_effet':  {
      handler(val) {
        if(val) {
          this.checkDateFormat()
          if (!this.checkerDateEffet(true)) {
            this.objetSanteActif.date_effet = null
            this.$refs.AssureRules.validate()
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'objetSanteActif.enfantCharge': {
      handler: function (old, nld) {
        if(old=='0'){
          this.enfantsArray = _.filter(this.enfantsArray, enf => enf.id);
        }
      },
      deep:true,
    },
    enfantStore: {
      handler: function (old, nld) {
        this.$http
          .get(`devis/getProspectDevisEnfants/${this.devis.id}`)
          .then(r => {
            this.mapEnfantForStore(r.data)
          })
          .catch(e => {
            console.log(e)
          })
      },
      immediate:true
    },
 
    prospect: {
       handler: function (old, nld) {
        this.prospect.original_civilite = old.civilite
        this.prospect.original_date_naissance = old.date_naissance
        this.prospect.moyen_contact.original_code_postal = old.moyen_contact.code_postal
        this.prospect.original_nom = old.nom
        this.prospect.original_prenom = old.prenom
        this.prospect.original_nom_naissance = old.nom_naissance
        this.prospect.original_code_postal_naissance = old.code_postal_naissance
        this.prospect.original_commune_naissance = old.commune_naissance    
        this.prospect.original_pays_naissance = old.pays_naissance
        this.prospect.moyen_contact.original_ville_id = old.moyen_contact.ville_id
        this.prospect.original_regime_obligatoire = old.regime_obligatoire
       },
       immediate:true
     },
     conjoint: {
       handler: function (old, nld) {
        this.conjoint.original_nom = old.nom
        this.conjoint.original_prenom = old.prenom
        this.conjoint.original_date_naissance   =old.date_naissance
        this.conjoint.original_civilite = old.civilite
        this.conjoint.original_nom = old.nom
        this.conjoint.original_prenom = old.prenom
        this.conjoint.original_nom_naissance = old.nom_naissance
        this.conjoint.original_code_postal_naissance = old.code_postal_naissance
        this.conjoint.original_commune_naissance = old.commune_naissance
        this.conjoint.original_pays_naissance = old.pays_naissance
        this.conjoint.moyen_contact.original_ville_id = old.moyen_contact.ville_id
        this.conjoint.original_regime_obligatoire = old.regime_obligatoire
       },
       immediate:true
     },
  },
   /*  beforeMount() {
    this.prospect.original_civilite = this.prospect.civilite
    this.prospect.original_date_naissance = this.prospect.date_naissance
    this.prospect.original_regime_obligatoire = this.prospect.regime_obligatoire
    this.prospect.moyen_contact.original_code_postal = this.prospect.moyen_contact.code_postal
    this.prospect.original_nom = this.prospect.nom
    this.prospect.original_prenom = this.prospect.prenom
    this.prospect.original_nom_naissance = this.prospect.nom_naissance
    this.prospect.original_code_postal_naissance = this.prospect.code_postal_naissance
    this.prospect.original_commune_naissance = this.prospect.commune_naissance    
    this.prospect.original_pays_naissance = this.prospect.pays_naissance
    this.prospect.original_regime_obligatoire = this.prospect.regime_obligatoire
    this.prospect.moyen_contact.original_ville_id = this.prospect.moyen_contact.ville_id

    this.conjoint.original_civilite = this.conjoint.civilite
    this.conjoint.original_date_naissance = this.conjoint.date_naissance
    this.conjoint.original_regime_obligatoire = this.conjoint.regime_obligatoire
    this.conjoint.original_nom = this.conjoint.nom
    this.conjoint.original_prenom = this.conjoint.prenom
    this.conjoint.original_nom_naissance = this.conjoint.nom_naissance
    this.conjoint.original_code_postal_naissance = this.conjoint.code_postal_naissance
    this.conjoint.original_commune_naissance = this.conjoint.commune_naissance
    this.conjoint.original_pays_naissance = this.conjoint.pays_naissance
    this.conjoint.original_regime_obligatoire = this.conjoint.regime_obligatoire
    this.conjoint.moyen_contact.original_ville_id = this.conjoint.moyen_contact.ville_id
    // this.orderExigences()
  }, */  
  mounted() {
    this.$v.$reset();
    this.$v.objetSanteActif.$touch();
    this.$v.enfantsArray.$touch();
    this.$refs.AssureRules.validate()
    this.initRegimeObjet(this.prospect.regime_obligatoire, 'SOUSCRIPTEUR', true)
    this.initRegimeObjet(this.conjoint.regime_obligatoire, 'CONJOINT', true)
    // if (!this.checkerDateEffet()) {
    //   this.objetSanteActif.date_effet = null
    //   this.$refs.AssureRules.validate()
    // }
    
    // this.orderExigences()
  },
  created() {
    this.$http
      .get(`tiers/getPays`)
      .then(r => {
        this.pays = r.data
        // console.log(r.data);
      })
      .catch(e => {
        console.log(e)
      })
  },
  methods: {
    initRegimeObjet(regime, type = "SOUSCRIPTEUR", isMounted = false) {
      if(regime != 'REGIME_AGRICOLE') {
        if(type == "SOUSCRIPTEUR")
          this.objetSanteActif.regime_obligatoire = regime
        else if(type == "CONJOINT") {
          this.objetSanteActif.regime_obligatoire_conjoint = regime
        }
      }
      else {
        if(type == "SOUSCRIPTEUR") {
          if(isMounted && (this.objetSanteActif.regime_obligatoire == 'EXPLOITANTS_AGRICOLES' || this.objetSanteActif.regime_obligatoire == 'SALARIE_AGRICOLE'))
            return 0
          else this.objetSanteActif.regime_obligatoire = null
        }
        else if(type == "CONJOINT") {
          if(isMounted && (this.objetSanteActif.regime_obligatoire_conjoint == 'EXPLOITANTS_AGRICOLES' || this.objetSanteActif.regime_obligatoire_conjoint == 'SALARIE_AGRICOLE'))
            return 0
          else this.objetSanteActif.regime_obligatoire_conjoint = null
        }
      } 
    },
    setPoursuitEtudeEnfantBySelectedRegime(data){
      data.forEach((enf)=>{
          if(enf.regime_obligatoire_enf == "REGIME_GENERAL" || (enf.regime_obligatoire_enf && this.prospect.regime_obligatoire && enf.regime_obligatoire_enf == this.prospect.regime_obligatoire)){
            enf.poursuit_etude = 1;
          }else{
            enf.poursuit_etude = 0;
          }
        })
        return data
    },
    checkDateFormat() {
      const format = 'YYYY-MM-DD'
      const format2 = 'DD/MM/YYYY'
      const date = moment(this.objetSanteActif.date_effet, format, true)
      const date2 = moment(this.objetSanteActif.date_effet, format2, true)
      if (date.isValid()) {
        this.objetSanteActif.date_effet = date.format(format2)
      } else if(date2.isValid()) {
        this.objetSanteActif.date_effet = date2.format(format2)
      }
    },
    getVilles(code) {
      if (code && code.length === 5) {
        this.$http
            .get(`/helpers/${code}/villes`)
            .then(res => {
              if (res.data?.length > 0) {
                this.villeOptions = [...res.data]
                this.prospect.moyen_contact.ville = this.villeOptions[0].id
              }
            })
            .catch(err => {
              console.log(err)
            })
      } else {
        this.villeOptions = []
      }
    },
    orderExigences() {
      let listExigences = ['Soins Courants', 'Hospitalisation', 'Optique', 'Dentaire', 'Aides auditives'],
        result = []
      this.exigences.forEach(function (a) {
        result[listExigences.indexOf(a.label)] = a
      })
      this.exigences = result
    },
    explicationExigenceNiveauLibel(exigenceLabel, exigenceNiveauLabel) {
      const removeAccentsExigenceLabel = exigenceLabel.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const valueToUpperCaseExigenceLabel = removeAccentsExigenceLabel.toUpperCase()

      const removeAccentsExigenceNiveauLabel = exigenceNiveauLabel.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const valueToUpperCaseExigenceNiveauLabel = removeAccentsExigenceNiveauLabel.toUpperCase()

      const valueSearch = valueToUpperCaseExigenceNiveauLabel + ' ' + valueToUpperCaseExigenceLabel

      let tableNiveauGarantie = {
        'NON SOINS COURANTS': 'Aucune prise en charge',
        'MIN SOINS COURANTS': 'Consultations et visites spécialistes et généralistes remboursées à 100%',
        'MOYEN SOINS COURANTS': 'Consultations et visites spécialistes et généralistes remboursées jusqu’à 150%',
        'FORT SOINS COURANTS': 'Consultations et visites spécialistes et généralistes remboursées jusqu’à 200%',
        'MAX SOINS COURANTS': 'Consultations et visites spécialistes et généralistes remboursées jusqu’à 300%',
        'MAXPLUS SOINS COURANTS': 'Consultations et visites spécialistes et généralistes remboursées à 300% et plus',

        'NON HOSPITALISATION': 'Aucune prise en charge',
        'MIN HOSPITALISATION': 'Frais de séjour, soins, honoraires, actes techniques remboursés à 100%',
        'MOYEN HOSPITALISATION': 'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 150%',
        'FORT HOSPITALISATION': 'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 200%',
        'MAX HOSPITALISATION': 'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 300%',
        'MAXPLUS HOSPITALISATION': 'Frais de séjour, soins, honoraires, actes techniques remboursés à 300% et plus',

        'NON OPTIQUE': 'Aucune prise en charge',
        'MIN OPTIQUE': 'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés à 100%',
        'MOYEN OPTIQUE': 'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 200€',
        'FORT OPTIQUE': 'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 300€',
        'MAX OPTIQUE': 'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 400€',
        'MAXPLUS OPTIQUE': 'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés à 400€ et plus',

        'NON DENTAIRE': 'Aucune prise en charge',
        'MIN DENTAIRE': 'Soins et prothèses dentaires à tarif libre remboursés à 100%',
        'MOYEN DENTAIRE': 'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 150%',
        'FORT DENTAIRE': 'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 200%',
        'MAX DENTAIRE': 'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 300%',
        'MAXPLUS DENTAIRE': 'Soins et prothèses dentaires à tarif libre remboursés à 300% et plus',

        'NON AIDES AUDITIVES': 'Aucune prise en charge',
        'MIN AIDES AUDITIVES': 'Equipement à tarif libre remboursé par la sécurité sociale remboursé à 100%',
        'MOYEN AIDES AUDITIVES': 'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 150%',
        'FORT AIDES AUDITIVES': 'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 250%',
        'MAX AIDES AUDITIVES': 'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 350%',
        'MAXPLUS AIDES AUDITIVES': 'Equipement à tarif libre remboursé par la sécurité sociale remboursé au delà de 350%'
      }
      return tableNiveauGarantie[valueSearch]
    },
    titleClass(word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    },
    checkEnfantValidateField(){
      let state=false;
      this.enfantsArray.map((enf)=>{
        if((enf.date_naissance!=enf.original_date_naissance && enf.original_date_naissance !='' && enf.original_date_naissance != null)
        ||(enf.nom!=enf.original_nom && enf.original_nom !='' && enf.original_nom !=null) 
        ||(enf.regime_obligatoire_enf!=enf.original_regime_obligatoire && enf.original_regime_obligatoire !='' && enf.original_regime_obligatoire !=null) 
        ||(enf.prenom!=enf.original_prenom && enf.original_prenom !='' && enf.original_prenom !=null) && enf.id ){
          state=true
          return state
        }
      })
      return state
    },
    mapEnfantForStore(enfants){
      this.enfantsArray=[]
      Object.values(this.enfantStore).forEach(enf => {
          let enfant={
          id:enf.lienable.id,
          civilite:enf.lienable.civilite,
          nom:enf.lienable.nom,
          prenom:enf.lienable.prenom,
          num_secu:enf.lienable.num_secu,
          numeroOrganisme:enf.lienable.numeroOrganisme,
          regime_obligatoire : enf.lienable.regime_obligatoire,
          date_naissance:enf.lienable.date_naissance ? moment(enf.lienable.date_naissance, 'YYYY-MM-DD').format('DD/MM/YYYY') : null,
          original_date_naissance:enf.lienable.date_naissance ? moment(enf.lienable.date_naissance, 'YYYY-MM-DD').format('DD/MM/YYYY') : null,
          original_nom : enf.lienable.nom,
          original_prenom : enf.lienable.prenom,
          original_regime_obligatoire : enf.lienable.regime_obligatoire,
          state:false,
          statut_gda:enf.lienable.statut_gda,
          poursuit_etude: 0,
          original_poursuit_etude: 0,
          
        }

        if(enfants && enfants.length>0){
          let checkExist      =_.find(enfants, function(e) { return e.personne_physique_id == enf.lienable.id; });
          let isPoursuitEtude =_.find(enfants, function(e) { return e.personne_physique_id == enf.lienable.id && e.poursuit_etude });

          if(checkExist) {
            enfant.state=true
            enfant.regime_obligatoire_enf = checkExist.regime_obligatoire_enf
          } else {
            enfant.regime_obligatoire_enf = enf.lienable.regime_obligatoire
          }

          if(isPoursuitEtude) {
            enfant.poursuit_etude          = 1
            enfant.original_poursuit_etude = 1
          }
        } else {
          enfant.regime_obligatoire_enf = enf.lienable.regime_obligatoire
        }
        this.enfantsArray.push(enfant)
      });
    },
    addEnfant(){
      this.enfantsArray.push({
        id:null,
        date_naissance:null,
        original_date_naissance: null,
        state:null,
        statut_gda: "BLANC",
        poursuit_etude: null,
        original_poursuit_etude: null,
        regime_obligatoire_enf:null
      })
    },
    removeEnfant(index){
      this.enfantsArray.splice(index, 1)
    },
    updateDevisLoiMadelin(){
          let dataMadelin={
              id:this.devis.id,
              loi_madelin:this.devis.loi_madelin
          }
          this.$http.post(`devis/updateDevisLoiMadelin`,dataMadelin).then((r) => {
          }).catch((err)=>{
              console.log(err)
          })
    },
    backStep() {
      this.$store.commit('setStepTarif', {
        step: {
          indexStep: 0,
          active: 'choix'
        }
      })
    },
    async checkValidateField(index) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      this.showLoading = true
      this.$v.$reset();
      this.$v.objetSanteActif.$touch();
      this.$v.enfantsArray.$touch();
     let enfantChecked = _.filter(this.enfantsArray, enf => enf.state );
      let enfantRegimeCheck = false
      for (let index = 0; index < enfantChecked.length; index++) {
          const enf = enfantChecked[index];
          if(!enf.regime_obligatoire_enf)
          {
            enfantRegimeCheck = true
          }
      }

      if (this.$v.objetSanteActif.$error || enfantRegimeCheck) {
        this.showLoading = false
        return 0;
      }

      if(!this.enfantsChecked){
        this.$toast({
          component: ToastificationContentVue,
          props: {
          title: 'Veuillez renseigner les informations relatives aux enfants à assurer. ',
          icon: 'XIcon',
          variant: 'danger',
          },
        })
        this.showLoading = false
        return 0
      }

      if(!this.enfantsHasValidDateNaissance){
        this.$toast({
          component: ToastificationContentVue,
          props: {
          title: 'Vous ne pouvez pas sélectionner d\'enfants de 28 ans et plus, à la date du jour',
          icon: 'XIcon',
          variant: 'danger',
          },
        })
        this.showLoading = false
        return 0
      }
  

      if (this.$v.objetSanteActif.$error || enfantRegimeCheck) {
        this.showLoading = false
        return 0;
      }
      const isValid = await this.$refs.AssureRules.validate()
      if (!isValid) {
        this.showLoading = false
        return 0
      }
      // const endDate = moment(this.objetSanteActif.date_effet, 'DD/MM/YYYY').subtract(55, 'years').format('YYYY-MM-DD')
      // const endDateConjoint = moment(this.objetSanteActif.date_effet, 'DD/MM/YYYY').subtract(40, 'years').format('YYYY-MM-DD')
      // const startDate = moment(this.objetSanteActif.date_effet, 'DD/MM/YYYY').subtract(96, 'years').add(1, 'days').format('YYYY-MM-DD')
      
      // const dateNaissanceProspect = moment(this.prospect.date_naissance, 'DD/MM/YYYY').format('YYYY-MM-DD')
      if (this.objetSanteActif.ria && !this.checkerDateEffet()) {
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: "La date d’effet doit être postérieure ou égale au " + this.riaDate + ' pour respecter le délai légal RIA',
            icon: 'XIcon',
            variant: 'danger'
          }
        })
        this.showLoading = false
        return 0
      } else if (!this.objetSanteActif.ria && !this.checkerDateEffet()) {
        this.showLoading = false
        return 0
      }
      if (this.objetSanteActif.ria) {
        const effetDate = moment(this.objetSanteActif.date_effet, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const riaDatemoment = moment(this.riaDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

        if (moment(effetDate).isBefore(moment(riaDatemoment))) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "La date d’effet doit être postérieure ou égale au " + this.riaDate + ' pour respecter le délai légal RIA',
              icon: 'XIcon',
              variant: 'danger'
            }
          })
          this.showLoading = false
          return 0
        }
      }

      // if (moment(dateNaissanceProspect).isBetween(startDate, endDate, null, '[]')) {
      //   this.errorDateNaissanceProspect = null
      // } else {
      //   this.errorDateNaissanceProspect = "L'âge de l’assuré principal doit être compris entre 55 et 95 ans"
      //   this.showLoading = false
      //   return 0
      // }

      // if (this.objetSanteActif.conjoint) {
      //   const compareDateProspectConjoint = moment(this.conjoint.date_naissance, 'DD/MM/YYYY').format('YYYY-MM-DD')
      //   if (moment(compareDateProspectConjoint).isBetween(startDate, endDateConjoint, null, '[]')) {
      //     this.errorDateNaissanceConjoint = null
      //   } else {
      //     this.errorDateNaissanceConjoint = "L'âge du conjoint doit être compris entre 40 et 95 ans"
      //     this.showLoading = false
      //     return 0
      //   }
      // } else {
      //   this.errorDateNaissanceConjoint = null
      // }

      if (this.getEtude.itemsRisque.ItemsRisque[index].garanties[0].garantieNiveauID.length == 0) {
        this.hasSelectedGarantie = true
        this.showLoading = false
        return 0
      } else {
        this.hasSelectedGarantie = false
      }

      this.unselectedExigenceIds = []
      this.getEtude.itemsRisque.ItemsRisque[index].exigences.forEach(element => {
          if (element.exigenceNiveauID.length == 0) {
            this.unselectedExigenceIds.push(element.id)
          }
      });

      if (this.unselectedExigenceIds.length > 0) {
        this.showLoading = false
        return 0
      }

      let resultEnfant = await this.checkEnfantValidateField();

      let resultOriginalData = await this.checkOriginalData();

      if (resultEnfant || resultOriginalData) {
      
        this.$swal({
          html: `<p class="text-justify" style="font-size: 15px">Attention, vous souhaitez modifier une donnée potentiellement tarifante pour un devis non encore souscrit ou un contrat souscrit par l'intermédiaire de BubbleIn.
                        <br><br>
                        Les devis en cours d'étude seront modifiés avec ces nouvelles informations. Les devis déjà envoyés ou les contrats en cours de signature seront classés sans suite et il conviendra de les refaire. Si vous avez souscrit un contrat, il conviendra de vérifier la nécessité de procéder à un avenant.
                        <br><br>
                        Souhaitez-vous confirmer cette modification ?</p>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
            html: 'text-left'
          },
          buttonsStyling: false
        })
          .then(confirmed => {
            if (confirmed.value) {
              this.updateDevisLoiMadelin()
              this.faireTarif(index)
                this.prospect.original_civilite = this.prospect.civilite
                this.prospect.original_date_naissance = this.prospect.date_naissance
                this.prospect.moyen_contact.original_code_postal = this.prospect.moyen_contact.code_postal 
                this.prospect.original_nom = this.prospect.nom
                this.prospect.original_prenom = this.prospect.prenom
                this.prospect.original_nom_naissance = this.prospect.nom_naissane
                this.prospect.original_code_postal_naissance = this.prospect.code_postal_naissance
                this.prospect.original_commune_naissance = this.prospect.commune_naissance    
                this.prospect.original_pays_naissance = this.prospect.pays_naissance
                this.prospect.moyen_contact.original_ville_id = this.prospect.moyen_contact.ville_id
                this.prospect.original_regime_obligatoire = this.prospect.regime_obligatoire

                this.conjoint.original_civilite = this.conjoint.civilite 
                this.conjoint.original_date_naissance = this.conjoint.date_naissance 
                this.conjoint.moyen_contact.original_code_postal = this.conjoint.moyen_contactcode_postal
                this.conjoint.original_nom = this.conjoint.nom
                this.conjoint.original_prenom = this.conjoint.prenom
                this.conjoint.original_nom_naissance = this.conjoint.nom_naissance
                this.conjoint.original_code_postal_naissance = this.conjoint.code_postal_naissance
                this.conjoint.original_commune_naissance = this.conjoint.commune_naissance    
                this.conjoint.original_pays_naissance = this.conjoint.pays_naissance
                this.conjoint.moyen_contact.original_ville_id = this.conjoint.moyen_contact.ville_id
                this.conjoint.original_regime_obligatoire = this.conjoint.regime_obligatoire
              // this.showLoading = false
            } else {
              this.showLoading = false
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }
          })
          .catch(() => {
            this.showLoading = false
          }).finally(() => {
          })
        
      } else {
        this.updateDevisLoiMadelin()
        this.faireTarif(index)
      }
    },

    checkOriginalData(){
        if((this.prospect.date_naissance !== this.prospect.original_date_naissance && this.prospect.original_date_naissance != '' && this.prospect.original_date_naissance != null) 
      //prospect  
      || (this.prospect.civilite != this.prospect.original_civilite && this.prospect.original_civilite != '' && this.prospect.original_civilite != null)
      || (this.prospect.nom != this.prospect.original_nom && this.prospect.original_nom !='' && this.prospect.original_nom!=null)
      || (this.prospect.prenom != this.prospect.original_prenom && this.prospect.original_prenom != '' && this.prospect.original_prenom != null)
      || (this.prospect.nom_naissance != this.prospect.original_nom_naissance && this.prospect.original_nom_naissance !='' && this.prospect.original_nom_naissance != null)
      || (this.prospect.code_postal_naissance != this.prospect.original_code_postal_naissance && this.prospect.original_code_postal_naissance !='' && this.prospect.original_code_postal_naissance != null)
      || (this.prospect.commune_naissance != this.prospect.original_commune_naissance && this.prospect.original_commune_naissance !='' && this.prospect.original_commune_naissance != null)
      || (this.prospect.pays_naissance != this.prospect.original_pays_naissance && this.prospect.original_pays_naissance !='' && this.prospect.original_pays_naissance != null)
      || (this.prospect.moyen_contact.ville_id!=this.prospect.moyen_contact.original_ville_id && this.prospect.moyen_contact.original_ville_id!='' && this.prospect.moyen_contact.original_ville_id != null)
      || (this.prospect.moyen_contact.code_postal != this.prospect.moyen_contact.original_code_postal && this.prospect.moyen_contact.original_code_postal != '' && this.prospect.moyen_contact.original_code_postal != null)
      || (this.prospect.original_regime_obligatoire != this.prospect.regime_obligatoire && this.prospect.original_regime_obligatoire != '' && this.prospect.original_regime_obligatoire != null)
      //Conjoint
      || (this.conjoint.date_naissance != this.conjoint.original_date_naissance && this.conjoint.original_date_naissance != '' && this.conjoint.original_date_naissance != null)
      || (this.conjoint.civilite != this.conjoint.original_civilite && this.conjoint.original_civilite != '' && this.conjoint.original_civilite != null)
      || (this.conjoint.nom != this.conjoint.original_nom && this.conjoint.original_nom !='' && this.conjoint.original_nom!=null)
      || (this.conjoint.prenom != this.conjoint.original_prenom && this.conjoint.original_prenom != '' && this.conjoint.original_prenom != null)
      || (this.conjoint.nom_naissance != this.conjoint.original_nom_naissance && this.conjoint.original_nom_naissance !='' && this.conjoint.original_nom_naissance != null)
      || (this.conjoint.code_postal_naissance != this.conjoint.original_code_postal_naissance && this.conjoint.original_code_postal_naissance !='' && this.conjoint.original_code_postal_naissance != null)
      || (this.conjoint.commune_naissance != this.conjoint.original_commune_naissance && this.conjoint.original_commune_naissance !='' && this.conjoint.original_commune_naissance != null)
      || (this.conjoint.pays_naissance != this.conjoint.original_pays_naissance && this.conjoint.original_pays_naissance !='' && this.conjoint.original_pays_naissance != null)
      || (this.conjoint.original_regime_obligatoire != this.conjoint.regime_obligatoire && this.conjoint.original_regime_obligatoire !='' && this.conjoint.original_regime_obligatoire != null))
      {
          return true
      }else{
        return false
      }
    },
    changeDisabledDate(day, onInput = false) {
      if(!onInput) {
        this.configdateEffet.disable = [
          function (date) {
            const today = new Date()
            today.setDate(today.getDate() + day)
            today.setHours(0, 0, 0, 0)
            return date < today
          },
          function (date) {
              const dateMaxSPVIE = new Date()
              dateMaxSPVIE.setFullYear(dateMaxSPVIE.getFullYear() + 1);
              dateMaxSPVIE.setHours(0, 0, 0, 0)
              const datePlusMonth = dateMaxSPVIE
              return datePlusMonth < date
          }
        ]
      }
    },
    checkerDateEffet(onIput = false) {
      const dateDuJour = moment().format('YYYY-MM-DD')
      const effetDate = moment(this.objetSanteActif.date_effet, 'DD/MM/YYYY', true)

      const dateDuJourPlusYears = moment().add(1, 'years').format('YYYY-MM-DD')
      if (this.objetSanteActif.ria) {
        let riaDateLocal = moment().add(35, 'days').format('YYYY-MM-DD')
        this.changeDisabledDate(35, onIput)
        if (this.devis.type_vente == 'optout') {
          riaDateLocal = moment().add(36, 'days').format('YYYY-MM-DD')
          this.changeDisabledDate(36, onIput)
        } else {
          riaDateLocal = moment().add(35, 'days').format('YYYY-MM-DD')
          this.changeDisabledDate(35, onIput)
        }

        if (effetDate.isValid() && !moment(effetDate.format('YYYY-MM-DD')).isBetween(riaDateLocal, dateDuJourPlusYears, null, '[]')) {
          return false
        }
      } else {
        this.changeDisabledDate(0, onIput)
        if (effetDate.isValid() && !moment(effetDate.format('YYYY-MM-DD')).isBetween(dateDuJour, dateDuJourPlusYears, null, '[]')) {
          return false
        }
      }
      return true
    },
    async faireTarif(index) {
      // this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_sante_actifs = this.objetSanteActif
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_sante_actifs.date_effet = this.objetSanteActif.date_effet
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_sante_actifs.conjoint = this.objetSanteActif.conjoint
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_sante_actifs.regime_obligatoire = this.objetSanteActif.regime_obligatoire
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_sante_actifs.regime_obligatoire_conjoint = this.objetSanteActif.regime_obligatoire_conjoint
      this.getEtude.Tiers = this.prospect
      let chooseRisque = this.getEtude.itemsRisque.ItemsRisque[0]
      let risqueItem = this.getEtude
      risqueItem.Enfant.Enfant=this.objetSanteActif.enfantCharge==0 ? [] : this.enfantsArray
      risqueItem.itemsRisque.ItemsRisque = []
      risqueItem.itemsRisque.ItemsRisque.push(chooseRisque)

      // risqueItem.objetSanteActif = this.objetSanteActif

      await this.persistObject(risqueItem)
      this.showLoading = false
      return new Promise((resolve, reject) => {
        resolve(true)
      })

    },
    async persistObject(risqueItem) {
      await this.$http
        .post(`portefeuilles/addDevisPortefeuille`, risqueItem)
        .then(response => {
          let enfants=response.data[1]
          let conjoint = response.data[2]

          this.$store.commit("setObjetEnfant", {
            Enfant: enfants,
          });
          this.$store.commit('setObjetConjoint', {
            Conjoint: conjoint
          })
          return this.getTarifData(risqueItem, 0, conjoint, enfants)
        })
        .catch(e => {
          console.error(e.response)
          this.errors = e.response.data.errors
        })
    },
    async getTarifData(risqueItem, risque, conjoint, enfants) {
      try {
        const garantiesValues = this.getEtude.itemsRisque.ItemsRisque[risque].garanties

        garantiesValues.forEach((item, index) => {
          if (garantiesValues[index].garantieNiveauID.length <= 0) {
            this.getEtude.itemsRisque.ItemsRisque[risque].garanties[index].garantieNiveauID = []
            this.getEtude.itemsRisque.ItemsRisque[risque].garanties[index].garantieNiveauID.push(
              garantiesValues[index].garantieniveaux.find(item => item.garantie_niveau_libel == 'Non').id
            )
          }
        })
        console.log("test", garantiesValues)
        risqueItem.itemsRisque.ItemsRisque[risque].garanties = this.getEtude.itemsRisque.ItemsRisque[risque].garanties

        let data = {
          conjoint: conjoint,
          enfant:enfants,
          assure: this.prospect,
          risque: {
            objet: risqueItem.itemsRisque.ItemsRisque[risque].objets,
            produits: risqueItem.itemsRisque.ItemsRisque[risque].produits,
            garanties: risqueItem.itemsRisque.ItemsRisque[risque].garanties,
            risque: risqueItem.itemsRisque.ItemsRisque[risque].risque,
            devis: risqueItem.itemsRisque.ItemsRisque[risque].devis.id
          }
        }

        await this.$http.post(`portefeuilles/getTarif`, data).then(response => {
          this.getEtude.itemsRisque.ItemsRisque[risque].produits.tarif = []
          this.getEtude.itemsRisque.ItemsRisque[risque].produits = response.data
          this.$store.commit('setItemsRisqueGlobal', {
            ItemsRisque: risqueItem.itemsRisque.ItemsRisque
          })
        })

        this.$store.commit('setStepTarif', {
          step: {
            indexStep: 2,
            active: 'comparatif'
          }
        })

        // this.showLoading = false
      } catch (e) {
        this.errors = e.response.data.errors
      }
    },
  }
}
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.title-custom-wizard {
  color: #4d25bc;
  margin-bottom: 20px;


}

@media only screen and (min-width: 700px) {
  #lg-popover .popover {
  width:600px;
  max-width:none; // Required for popovers wider than 276px (Bootstrap's max-width for popovers)
}
}



label {
  font-weight: 900;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder {
  /* Recent browsers */
  text-transform: none;
}


</style>
